import {
    INIT_TABLE_OF_CONTENTS,
    OPEN_TABLE_OF_CONTENTS,
    CLOSE_TABLE_OF_CONTENTS,
} from './actions'
import { set } from 'immutadot'

const initialState = {
    isOpened: false,
    table: [],
}

export const tableOfContents = (state = initialState, { type, ...action}) => {
    switch (type)
    {
        case INIT_TABLE_OF_CONTENTS:
            return set(state, 'table', action.tableOfContents)

        case OPEN_TABLE_OF_CONTENTS:
            return set(state, 'isOpened', true)

        case CLOSE_TABLE_OF_CONTENTS:
            return set(state, 'isOpened', false)

        default:
            return state
    }
}
